import { Box, Link, Stack, Typography } from '@mui/material';

// The links every page ends with (from the session's links)
export default function AppFooter({ session }) {
  const links = session?.links;
  return (
    <Box component="footer" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2,
      flexWrap: 'wrap', px: { xs: 2, md: 5 }, py: 2.5 }}>
      <Typography variant="body2" color="text.secondary">© {new Date().getFullYear()} TrialX</Typography>
      {links && (
        <Stack direction="row" spacing={3}>
          <Link href={links.terms_of_use} target="_blank" rel="noopener noreferrer" underline="hover"
                sx={{ fontSize: 14, fontWeight: 500 }}>
            Terms of Use
          </Link>
          <Link href={links.privacy_policy} target="_blank" rel="noopener noreferrer" underline="hover"
                sx={{ fontSize: 14, fontWeight: 500 }}>
            Privacy Policy
          </Link>
        </Stack>
      )}
    </Box>
  );
}
